export default __webpack_public_path__ + "static/museo-sans-bold-4a52725fe44ad501b363e71b6e06f0cc.ttf";